<template>
    <div class="company-skeleton">
  
      <div class="main-column">
  
        <!-- Главная карточка -->
  
        <div class="card">
          <div class="banner skeleton"></div>
  
          <div class="logo skeleton"></div>
  
          <div class="subscribe skeleton"></div>
  
          <div class="title skeleton"></div>
  
          <div class="subtitle skeleton"></div>
  
          <div class="line skeleton"></div>
          <div class="line skeleton"></div>
          <div class="line short skeleton"></div>
        </div>
  
        <!-- Карта -->
  
        <div class="card">
          <div class="heading skeleton"></div>
          <div class="map skeleton"></div>
        </div>
  
        <!-- Соцсети -->
  
        <div class="card">
          <div class="heading skeleton"></div>
  
          <div class="socials">
            <div
              v-for="i in 6"
              :key="i"
              class="social skeleton"
            />
          </div>
        </div>
  
        <!-- Работники -->
  
        <div class="card">
          <div class="heading skeleton"></div>
  
          <div class="workers">
            <div
              v-for="i in 4"
              :key="i"
              class="worker skeleton"
            />
          </div>
        </div>
  
      </div>
  
      <!-- Правая колонка -->
  
      <div class="sidebar">
  
        <div
          v-for="i in 4"
          :key="i"
          class="vacancy-card"
        >
  
          <div class="vacancy-image skeleton"></div>
  
          <div class="vacancy-title skeleton"></div>
  
          <div class="vacancy-line skeleton"></div>
  
          <div class="vacancy-line short skeleton"></div>
  
        </div>
  
      </div>
  
    </div>
  </template>
  <style scoped>
  * {
    box-sizing: border-box;
  }
  
  /* =========================================================
     THEME
  ========================================================= */
  
  .company-skeleton {
    --page-bg: #f4f6f9;
    --card-bg: #ffffff;
    --card-border: rgba(30, 41, 59, 0.08);
    --card-shadow: 0 12px 34px rgba(15, 23, 42, 0.06);
  
    --skeleton-bg: #e7ecf2;
    --skeleton-bg-strong: #dde4ec;
    --skeleton-highlight: rgba(255, 255, 255, 0.72);
  
    width: 1200px;
    margin: 40px auto 120px;
    padding: 24px;
  
    display: flex;
    gap: 32px;
  
    background: var(--page-bg);
    border-radius: 24px;
  }
  
  [data-theme="dark"] .company-skeleton {
    --page-bg: #17181c;
    --card-bg: #222329;
    --card-border: rgba(255, 255, 255, 0.07);
    --card-shadow: 0 16px 40px rgba(0, 0, 0, 0.3);
  
    --skeleton-bg: #2c2e35;
    --skeleton-bg-strong: #32343c;
    --skeleton-highlight: rgba(255, 255, 255, 0.07);
  }
  
  /* =========================================================
     LAYOUT
  ========================================================= */
  
  .main-column {
    width: 700px;
    min-width: 0;
  }
  
  .sidebar {
    width: 380px;
    min-width: 0;
  }
  
  /* =========================================================
     CARDS
  ========================================================= */
  
  .card,
  .vacancy-card {
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    box-shadow: var(--card-shadow);
  }
  
  .card {
    padding: 24px;
    margin-bottom: 28px;
  
    border-radius: 20px;
  }
  
  .vacancy-card {
    padding: 18px;
    margin-bottom: 18px;
  
    border-radius: 18px;
  }
  
  /* =========================================================
     HERO
  ========================================================= */
  
  .banner {
    width: 100%;
    height: 220px;
  
    border-radius: 16px;
  }
  
  .logo {
    position: relative;
    z-index: 2;
  
    width: 110px;
    height: 110px;
  
    margin-top: -55px;
    margin-left: 20px;
  
    border: 5px solid var(--card-bg);
    border-radius: 50%;
  
    box-shadow:
      0 10px 26px rgba(15, 23, 42, 0.12);
  }
  
  [data-theme="dark"] .logo {
    box-shadow:
      0 12px 28px rgba(0, 0, 0, 0.32);
  }
  
  .subscribe {
    width: 150px;
    height: 38px;
  
    margin-top: -40px;
    margin-left: auto;
  
    border-radius: 999px;
  }
  
  .title {
    width: 260px;
    height: 26px;
  
    margin-top: 30px;
  
    border-radius: 9px;
  }
  
  .subtitle {
    width: 180px;
    height: 15px;
  
    margin-top: 14px;
  
    border-radius: 7px;
  }
  
  .line {
    width: 100%;
    height: 14px;
  
    margin-top: 16px;
  
    border-radius: 7px;
  }
  
  .line.short {
    width: 60%;
  }
  
  /* =========================================================
     MAP
  ========================================================= */
  
  .heading {
    width: 180px;
    height: 20px;
  
    margin-bottom: 20px;
  
    border-radius: 8px;
  }
  
  .map {
    width: 100%;
    height: 260px;
  
    border-radius: 16px;
  }
  
  /* =========================================================
     SOCIALS
  ========================================================= */
  
  .socials {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  
    gap: 20px;
  }
  
  .social {
    width: 48px;
    height: 48px;
  
    flex-shrink: 0;
  
    border-radius: 50%;
  }
  
  /* =========================================================
     WORKERS
  ========================================================= */
  
  .workers {
    display: flex;
    gap: 16px;
  
    overflow: hidden;
  }
  
  .worker {
    width: 150px;
    height: 170px;
  
    flex-shrink: 0;
  
    border-radius: 16px;
  }
  
  /* =========================================================
     VACANCIES
  ========================================================= */
  
  .vacancy-image {
    width: 100%;
    height: 130px;
  
    border-radius: 14px;
  }
  
  .vacancy-title {
    width: 70%;
    height: 18px;
  
    margin-top: 18px;
  
    border-radius: 8px;
  }
  
  .vacancy-line {
    width: 100%;
    height: 12px;
  
    margin-top: 14px;
  
    border-radius: 6px;
  }
  
  .vacancy-line.short {
    width: 60%;
  }
  
  /* =========================================================
     SHIMMER
  ========================================================= */
  
  .skeleton {
    position: relative;
  
    overflow: hidden;
  
    background: var(--skeleton-bg);
  }
  
  .banner,
  .map,
  .vacancy-image {
    background: var(--skeleton-bg-strong);
  }
  
  .skeleton::after {
    content: "";
  
    position: absolute;
    inset: 0;
  
    transform: translateX(-100%);
  
    background:
      linear-gradient(
        90deg,
        transparent 0%,
        var(--skeleton-highlight) 50%,
        transparent 100%
      );
  
    animation: shimmer 1.35s ease-in-out infinite;
  }
  
  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
  
  /* =========================================================
     TABLET
  ========================================================= */
  
  @media (max-width: 1100px) {
    .company-skeleton {
      width: calc(100% - 32px);
  
      gap: 22px;
    }
  
    .main-column {
      flex: 1;
      width: auto;
    }
  
    .sidebar {
      width: 320px;
    }
  
    .worker {
      width: 135px;
    }
  }
  
  /* =========================================================
     MOBILE
  ========================================================= */
  
  @media (max-width: 768px) {
    .company-skeleton {
      width: 100%;
      margin: 0 0 100px;
      padding: 14px;
  
      flex-direction: column;
      gap: 18px;
  
      border-radius: 0;
    }
  
    .main-column,
    .sidebar {
      width: 100%;
    }
  
    .card {
      padding: 16px;
      margin-bottom: 16px;
  
      border-radius: 18px;
    }
  
    .vacancy-card {
      padding: 15px;
      margin-bottom: 14px;
    }
  
    .banner {
      height: 180px;
    }
  
    .logo {
      width: 84px;
      height: 84px;
  
      margin-top: -42px;
      margin-left: 14px;
  
      border-width: 4px;
    }
  
    .subscribe {
      width: 120px;
      height: 34px;
  
      margin-top: -28px;
    }
  
    .title {
      width: 62%;
      height: 22px;
  
      margin-top: 25px;
    }
  
    .subtitle {
      width: 42%;
    }
  
    .map {
      height: 220px;
    }
  
    .socials {
      gap: 14px;
    }
  
    .social {
      width: 42px;
      height: 42px;
    }
  
    .workers {
      gap: 12px;
    }
  
    .worker {
      width: 128px;
      height: 150px;
    }
  
    .vacancy-image {
      height: 150px;
    }
  }
  
  /* =========================================================
     SMALL MOBILE
  ========================================================= */
  
  @media (max-width: 430px) {
    .company-skeleton {
      padding: 10px;
    }
  
    .card {
      padding: 14px;
    }
  
    .banner {
      height: 160px;
    }
  
    .logo {
      width: 76px;
      height: 76px;
  
      margin-top: -38px;
    }
  
    .subscribe {
      width: 105px;
      height: 32px;
    }
  
    .map {
      height: 190px;
    }
  
    .social {
      width: 38px;
      height: 38px;
    }
  
    .worker {
      width: 115px;
      height: 140px;
    }
  }
  
  @media (prefers-reduced-motion: reduce) {
    .skeleton::after {
      animation: none;
    }
  }
  </style>